module.exports = __webpack_public_path__ + "img/item-bg.4ae4aa12.png";